export default __webpack_public_path__ + "static/media/link.8288f188.svg";